import React, { useState } from "react";
import { FiEdit2, FiShare2 } from "react-icons/fi";
import EditCampaignModal from "../modals/EditCampaignModal";
import ShareCampaignModal from "../modals/ShareCampaignModal";

const CampaignItem = ({ campaign, isSelected, children, onSelect, isShared = false }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);

  const handleEditClick = (e) => {
    e.stopPropagation(); // Prevent triggering the campaign selection
    setIsEditModalOpen(true);
  };

  const handleShareClick = (e) => {
    e.stopPropagation(); // Prevent triggering the campaign selection
    setIsShareModalOpen(true);
  };

  const handleCampaignClick = () => {
    if (onSelect) {
      onSelect(campaign.id);
    }
  };

  return (
    <div className="flex flex-col">
      <div className="flex justify-between items-center">
        <div
          onClick={handleCampaignClick}
          className={`flex-grow p-3 border border-gray-300 rounded-lg ${isSelected ? 'bg-sky-100' : 'bg-white'} text-black cursor-pointer hover:bg-sky-50 transition-colors`}>
          <h3 className="font-semibold text-sky-900 mb-2">{campaign.title}</h3>
        </div>
        <div className="flex items-center space-x-2 ml-2">
          {!isShared && (
            <FiShare2
              className="text-gray-500 hover:text-gray-700 cursor-pointer flex-none"
              onClick={handleShareClick}
              title="Share campaign"
            />
          )}
          <FiEdit2
            className="text-gray-500 hover:text-gray-700 cursor-pointer flex-none"
            onClick={handleEditClick}
            title={isShared ? "Remove from shared" : "Edit campaign"}
          />
        </div>
      </div>
      {/* Always render children, regardless of selection state */}
      {children}
      <EditCampaignModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        campaign={campaign}
        isShared={isShared}
      />
      <ShareCampaignModal
        isOpen={isShareModalOpen}
        onClose={() => setIsShareModalOpen(false)}
        campaign={campaign}
      />
    </div>
  );
};

export default CampaignItem;
